import React,{ useEffect, useState } from 'react'
import { TypeAnimation } from 'react-type-animation'
import niño from '../assets/logo2.png'
import niño2 from '../assets/logo3.png'
import fondo from '../assets/fondo2.png'
// Para usar si necesito degradar colores className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white "
const MisionVision = () => {
  const [mostrarPrimeraImagen, setMostrarPrimeraImagen] = useState(true)

  useEffect(() => {
    const intervalo = setInterval(() => {
      setMostrarPrimeraImagen(prev => !prev) // Alterna el valor booleano
    }, 3000)

    return () => clearInterval(intervalo) // Limpieza al desmontar
  }, [])

  const imagenActual = mostrarPrimeraImagen ? niño : niño2
  return (
    <div
      name="quehacemos"
      className="w-full h-screen  bg-cover bg-center relative "
      style={{
        backgroundImage: `url(${fondo})`,
      }}>
        

       <div className="max-w-screen-lg px-4 mx-auto flex flex-col md:flex-row items-center justify-center w-full h-full gap-8 pt-10 ">
        {/* TEXTO */}
        <div className="w-full md:w-1/2">
          <p className="text-2xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-5xl font-bold text-orange-one">
            Sembramos valores para construir un futuro mejor.
          </p>

          <p className="text-1xl sm:text-2xl mt-6 text-green-one">
            <strong>Misión:</strong> Somos una fundación que fortalece el desarrollo integral de los niños, jóvenes y sus familias para formar líderes que impacten en la sociedad.
          </p>
          <p className="text-1xl sm:text-2xl mt-6 text-green-one">
            <strong>Visión:</strong> Ser una fundación reconocida por transformar positivamente la vida de niños, jóvenes y sus familias, contribuyendo al desarrollo de comunidades más fuertes, solidarias y comprometidas con el bienestar social.

          </p>
        </div>

        {/* IMAGEN */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={imagenActual}
            alt="Niño"
            className="rounded-xl object-cover w-full max-w-md h-auto shadow-lg"
          />
        </div>
      </div>

    </div>
    
  )
}

export default MisionVision